import { anyToSupportedISO6391LanguageCode } from 'shared/utils/locale/anyToSupportedISO6391LanguageCode';
import { ProjectInDto } from '../types/dto';
import { ProjectEntity } from '../types/entity';

export function projectInDtoToEntity(
  project: ProjectInDto,
  existing?: ProjectEntity
): ProjectEntity {
  return {
    _id: project._id,
    code: project.code ?? existing?.code ?? '',
    createdAt: project.createdAt,
    createdBy: project.createdBy,
    modifiedAt: project.modifiedAt,
    modifiedBy: project.modifiedBy,
    deleted: project.deleted ? 1 : 0,
    clientId: project.clientId,
    name: project.name,
    timezone: project.timezone,
    budget: project.budget,
    currency: project.currency,
    projectStartDate: project.projectStartDate ?? '',
    projectEndDate: project.projectEndDate ?? '',
    localeCode: anyToSupportedISO6391LanguageCode(project.localeCode),
    processes: project.processes,
  };
}
